import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DevPanelWrapperLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-devpanelwrapper" */ "./DevPanelContainer")).then((wrapper)=>{
        return {
            default: wrapper.DevPanelContainer
        };
    });
export const LazyDevPanelContainer = /*#__PURE__*/ lazy(DevPanelWrapperLazyLoader);
